// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyAvailabilityV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyAvailabilityConfirmResponseV2WebDto,
  UserPropertyAvailabilityConfirmV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Path =
  '/api/web/v2/users/properties/availability/confirm';

/**
 * Confirm listing availability
 */
export const RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm = (
  postData: UserPropertyAvailabilityConfirmV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyAvailabilityConfirmV2RequestDto,
    UserPropertyAvailabilityConfirmResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
